import React, { useMemo, useRef, useState } from "react";
import ModalBox from "../../components/modal/ModalBox";
import {
  allowAlphaNumericWithSpace,
  allowNumber,
  regex,
} from "../../utils/regex";
import commonMessages from "../../utils/commonMessages";
import { Avatar } from "@mui/material";
import { toastMessage } from "../../utils/toastMessage";
import { Input, Select, TextArea } from "../../components/Form";
import { addDiscountApi, editDiscountApi } from "../../services/discountManagement";
import useButtonLoader from "../../hooks/UseButtonLoader";
import JoditEditor from "jodit-react";

const EditMembership = ({
  editMembershipModal,
  setEditMembershipModal,
  fetchDiscountHandler,
  buttonType,
  selectedData,
  setSelectedData
}) => {
  const [error, setError] = useState({});
  const [image, setImage] = useState("");
  const { imageFileRegex } = regex;
  const { IMAGE_FORMAT } = commonMessages;
  const [buttonref, buttonLoader] = useButtonLoader("Save");

  const modalClose = () => {
    setError({});
    setImage("")
    setSelectedData({});
    setEditMembershipModal(false);
  };

  const validation = () => {
    let status = true;
    let error = {};

    if (!selectedData?.title) {
      error["title"] = "Memebership Name is required *";
      status = false;
    }
    // if (!selectedData?.details || selectedData?.details==="<p><br></p>") {
    //   error["details"] = "Detail is required *";
    //   status = false;
    // }
    if (
        !selectedData?.details ||
        selectedData?.details === "<p><br></p>"
      ) {
        error["details"] = "Detail is required *";
        status = false;
      }
    if (!selectedData?.membershipPrice) {
      error["membershipPrice"] = "Price is required *";
      status = false;
    }
    if (!selectedData?.membershipDiscountPrice) {
      error["membershipDiscountPrice"] = "Discount price is required *";
      status = false;
    }
    if (!selectedData?.discountPercentage) {
      error["discountPercentage"] = "Discount percentage is required *";
      status = false;
    }
    if (!selectedData?.planType) {
      error["planType"] = "Plan type is required *";
      status = false;
    }

    if (!image && !image?.name && !selectedData.image) {
      error["membershipDiscountImage"] = "Image is required *";
      status = false;
    }
    setError(error);
    return status;
  };

  // const imageHandler = async (e) => {
  //   e.preventDefault();
  //   if (e.target.files.length > 0) {
  //     if (imageFileRegex.test(e.target.files[0].name)) {
  //       setImage(e.target.files[0]);
  //     } else {
  //       e.target.value = "";
  //       setImage("");
  //       toastMessage(IMAGE_FORMAT, "error", "imageFormat");
  //     }
  //   } else {
  //     e.target.value = "";
  //     setImage("");
  //   }
  // };


  const imageHandler = async (e) => {
    e.preventDefault();
    const { files } = e.target;

    if (files.length === 0) {
      clearInputAndImageState(e);
      return;
    }

    const file = files[0];
    const fileName = file.name.toLowerCase();
    const isGif = fileName.endsWith(".gif");
    const isImage = imageFileRegex.test(fileName);


    if (isGif) {
      handleGif(file, e);
    } else if (isImage) {
      // setType("image");
      handleImage(file, e);
    }else {
      handleInvalidFileFormat(e);
    }
  };

  const clearInputAndImageState = (e) => {
    e.target.value = "";
    setImage("");
  };

  const handleGif = async (file, e) => {
      setImage(file);
  };
  

  const handleImage = async (file, e) => {
      setImage(file);
    
  };

  const handleInvalidFileFormat = (e) => {
    toastMessage(
      "Invalid format: Only Audio and images and videos supported",
      "error",
      "InvalidFormat"
    );
    clearInputAndImageState(e);
  };


  const editMembershipHandler = async () => {
    if (validation()) {
      try {
        buttonLoader(true);
        const formData = new FormData();
        formData.append("title", selectedData.title || "");
        formData.append("membershipDiscountId",selectedData._id)
        formData.append("type", buttonType);
        formData.append("details", selectedData.details || "");
        formData.append("membershipPrice", selectedData.membershipPrice);
        formData.append(
          "membershipDiscountPrice",
          selectedData.membershipDiscountPrice
        );
        formData.append(
          "discountPercentage",
          selectedData.discountPercentage
        );
        formData.append("planType", selectedData.planType);
        formData.append(
          "membershipDuration",
          1
        );
        if (image && image?.name) {
          formData.append("membershipDiscountImage", image);
        }
        const { data } = await editDiscountApi(formData);
        if (data.code === 200) {
          toastMessage(data.message, "success", "addCoupon");
          fetchDiscountHandler();
          modalClose();
        } else {
          toastMessage(data.message, "error", "addCoupon");
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        buttonLoader(false);
      }
    }
  };

  const editor = useRef(null);

  const config = useMemo(
    () => ({
      readonly: false,
      placeholer:"",
      toolbar: true,
      spellcheck: true,
      language: "en",
      toolbarButtonSize: "medium",
      showCharsCounter: true,
      showWordsCounter: true,
      showXPathInStatusbar: false,
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      uploader: {
        insertImageAsBase64URI: true,
      },
      controls: {
        font: {
          command: "fontname",
          list: {
            "'Open Sans',sans-serif": "Open Sans",
            "Helvetica,sans-serif": "Helvetica",
            "Arial,Helvetica,sans-serif": "Arial",
            "Georgia,serif": "Georgia",
            "Impact,Charcoal,sans-serif": "Impact",
            "Tahoma,Geneva,sans-serif": "Tahoma",
            "'Times New Roman',Times,serif": "Times New Roman",
            "Verdana,Geneva,sans-serif": "Verdana",
            "Consolas,monaco,monospace": "Consolas",
          },
        },
      },
    }),
    []
  );

  return (
    <ModalBox
      status={editMembershipModal}
      onClose={modalClose}
      title={"Edit Membership"}
      size={"sm"}
      closeIcon
      custom
      customizedFooter={
        <div className="model_custom_footer">
          <button
            className="btn_size"
            ref={buttonref}
            onClick={editMembershipHandler}
          >
            Save
          </button>
        </div>
      }
    >
      <div>
        <div className="form-group mb-2">
          <Input
            type="text"
            name="title"
            value={selectedData.title || ""}
            required
            onChange={(e) => {
              const sanitizedText = allowAlphaNumericWithSpace(e.target.value);
              setSelectedData({
                ...selectedData,
                ["title"]: sanitizedText,
              });
            }}
            placeholder="Membership Name"
            className={`form-control`}
            label={"Membership Name"}
            error={!selectedData.title && error.title}
            maxLength={30}
          />
        </div>
        <div className="form-group mb-2" id="myjoditEditor">
          {/* <TextArea
            type="text"
            name="details"
            value={selectedData.details || ""}
            required
            onChange={(e) => {
              const sanitizedText = allowAlphaNumericWithSpace(e.target.value);
              setSelectedData({
                ...selectedData,
                ["details"]: sanitizedText,
              });
            }}
            placeholder="Detail"
            className={`form-control`}
            label={"Detail"}
            error={!selectedData.details && error.details}
            maxLength={500}
          /> */}
             <label className="my-1 text-dark">Detail</label>
          {/* <TextArea
            type="text"
            name="details"
            value={selectedData.details || ""}
            required
            onChange={(e) => {
              const sanitizedText = allowAlphaNumericWithSpace(e.target.value);
              setMembershipField({
                ...membershipField,
                ["details"]: sanitizedText,
              });
            }}
            placeholder="Detail"
            className={`form-control`}
            label={"Detail"}
            error={!membershipField.details && error.details}
            maxLength={500}
          /> */}
          <JoditEditor
            ref={editor}
            value={selectedData.details}
            tabIndex={1}
            onBlur={(e) => {
              setSelectedData({
                ...selectedData,
                details: e,
              });
            }}
            config={config}
          />
             {error?.details && (
            <p
              className={`invalid-feedback ${
                !selectedData.details ||
                selectedData.details === "<p><br></p>"
              } && d-block`}
            >
              {error?.details}
            </p>
          )}
        </div>
        <div className="form-group mb-2">
        <Select
            name="planType"
            value={selectedData.planType}
            required
            onChange={(e) => {
              setSelectedData({
                ...selectedData,
                planType: e.target.value,
              });
            }}
            placeholder="Vastu Category Title"
            className={`form-control`}
            label={"Plan Type"}
            error={!selectedData.planType && error.planType}
            maxLength={40}
          >
            <option value="">Select Plan</option>
            <option value="GOLD">Gold</option>
            <option value="SILVER">Silver</option>
            <option value="OTHERS">Others</option>
            </Select>
            </div>

        <div className="form-group mb-2">
          <Input
            type="text"
            name="membershipPrice"
            value={selectedData.membershipPrice || ""}
            required
            onChange={(e) => {
              const sanitizedText = allowNumber(e.target.value);
              setSelectedData({
                ...selectedData,
                ["membershipPrice"]: sanitizedText,
              });
            }}
            placeholder="Price"
            className={`form-control`}
            label={"Membership Price"}
            error={!selectedData.membershipPrice && error.membershipPrice}
            maxLength={4}
          />
        </div>

        <div className="form-group mb-2">
          <Input
            type="text"
            name="membershipDiscountPrice"
            value={selectedData.membershipDiscountPrice || ""}
            maxLength={4}
            required
            onChange={(e) => {
              const sanitizedText = allowNumber(e.target.value);
              setSelectedData({
                ...selectedData,
                ["membershipDiscountPrice"]: sanitizedText,
              });
            }}
            placeholder=" Membership Discount Price "
            className={`form-control`}
            label={"Discount"}
            error={
              !selectedData.membershipDiscountPrice &&
              error.membershipDiscountPrice
            }
          />
        </div>
        <div className="form-group mb-2">
          <Input
            type="text"
            name="discountPercentage"
            value={selectedData.discountPercentage || ""}
            required
            onChange={(e) => {
              const sanitizedText = allowNumber(e.target.value);
              setSelectedData({
                ...selectedData,
                ["discountPercentage"]: sanitizedText,
              });
            }}
            placeholder="Membership Discount Percentage"
            className={`form-control`}
            label={"Membership Discount Percentage"}
            error={
              !selectedData.discountPercentage &&
              error.discountPercentage
            }
            maxLength={500}
          />
        </div>
        <div className="form-group my-2">
          <Input
            type="file"
            accept="image/*"
            name="membershipDiscountImage"
            required
            onChange={(e) => imageHandler(e)}
            placeholder="Image"
            className={`form-control `}
            label={"Image"}
            error={!image && error.membershipDiscountImage}
          />
        </div>

        <div>
            <>
              <Avatar
                variant="square"
                sx={{
                  width: "100%",
                  borderRadius: 1,
                  height: 140,
                  border: "1px solid #FF8989",
                }}
                src={image && image.name ? URL.createObjectURL(image) : selectedData.image}

              />
            </>
        </div>
      </div>
    </ModalBox>
  );
};

export default EditMembership;
